// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.header {
    display: flex;
    flex-direction: column;
    position: relative;
    /*padding: 25px 25px;*/
    position: fixed; /* 상단 고정 */
    top: 0; /* 화면 상단에 고정 */
    width: 100%; /* 화면 전체 너비를 차지하도록 설정 */
    z-index: 1000; /* 다른 요소들 위에 표시되도록 설정 */
    /*background: rgba(255, 255, 255, 0.2);*/

    background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0.2), /* 상단에서 60% 불투명도 */
            rgba(255, 255, 255, 0.1), /* 중간에서 40% 불투명도 */
            rgba(255, 255, 255, 0)    /* 하단에서 완전 투명 */
    );
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
}
.dot{
    color: #889daa;
    margin: 0 5px;
}

.header.scrolled {
    background: rgba(255, 255, 255, 1); /* 스크롤 시 흰색 배경 */
    border-bottom: 2px solid #a7c898; /* 스크롤 시 테두리 변경 */
    z-index: 1000;
    .upper{
        background-color: #a7c898;
    }

}


.upper{
    padding: 8px 50px;
    /*background-color: rgb(198, 225, 251);*/
    width:100%;
    top: 0;
    /*padding: 10px 0;*/
    box-sizing: border-box;
    /*justify-content: center;*/
    /*align-items: center;*/

}


.upper .upnav-menu  ul li {
    list-style: none;
    display: flex;
    justify-content: center;
    padding: 0;
    margin: 0;
}
.upnav-menu a {
    text-decoration: none;
    color: #5d6b73;
}
.upnav-menu a:hover {
    text-decoration: none;
    color: #6aaa7d;
}

.upnav-menu ul {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
}

.upper .upnav-menu2  ul li {
    list-style: none;
    display: flex;
    justify-content: center;
    padding: 0;
    margin: 0;
}
.upnav-menu2 a{
    text-decoration: none;
    color: #5d6b73;
}
.upnav-menu2 ul {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
    position: absolute;
    right: 20px;
    top: 8px;
}
.upnav-menu2 a:hover {
    text-decoration: none;
    color: #6aaa7d;
}

/*.lower{*/
/*    padding: 25px 25px;*/
/*    width:100%;*/
/*    justify-content: center;*/
/*    align-items: center;*/
/*    background-color: #f8f9fa;*/
/*!*}*!*/
/*.upper {*/
/*    display: flex;*/
/*    justify-content: flex-end; !* 오른쪽 정렬 *!*/
/*    padding: 10px 25px;*/
/*    background-color:#E1BEE1;*/
/*    width: 100%;*/
/*}*/
.lower {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 30px 20px;
    position: relative;
}


.logo {
    position: absolute;
    left: 50px;

}

.logo img {
    height:70px;

}



.nav-menu ul {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
}


.nav-menu li {
    margin-right: 40px;
    position: relative;

}

.nav-menu li:last-child {
    margin-right: 0;
}

.nav-menu li:hover .dropdown-container,
.dropdown-container:hover {
    display: flex; /* 드롭다운 메뉴가 보이도록 설정 */
}
.nav-menu li:hover{
    display: flex; /* 드롭다운 메뉴가 보이도록 설정 */
}
.dropdown-container{
    display: flex; /* 드롭다운 메뉴가 보이도록 설정 */
}
.nav-menu a {
    text-decoration: none;
    color: #565b61;
    font-weight: bold;

}



.navtitle {
    color: rgb(0, 0, 0);
    font-weight: bold;
    cursor: pointer;
    /*filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.7))*/
    /*drop-shadow(0 0 2px rgba(255, 255, 255, 0.7))*/
    /*drop-shadow(0 0 2px rgba(255, 255, 255, 0.7));*/
    position: relative; /* ::after 가상 요소를 사용하기 위해 position을 relative로 설정 */
}

.navtitle::after {
    content: ''; /* 내용 없이 가상 요소 생성 */
    position: absolute;
    bottom: -40px; /* 아래로 20px 확장 */
    left: 0;
    right: 0;
    height: 20px; /* 20px의 hover 영역 추가 */
    /* 확장된 영역에 마우스를 올리면 드롭다운이 보이도록 설정 */
}

.navtitle:hover,
.navtitle::after:hover {
    color: #6aaa7d; /* hover 시 색상 변경 */
}

.navtitle:hover .dropdown-container,
.navtitle::after:hover .dropdown-container {
    display: flex; /* 드롭다운 메뉴가 보이도록 설정 */
}

.nav-menu a:hover {
    color: #6aaa7d;
}
.nav-menu li:hover .navtitle,
.nav-menu li:hover .dropdown-container:hover {
    color: #6aaa7d; /* 드롭다운 위로 커서를 옮겼을 때에도 navtitle 색상 유지 */
}

.navtitle.active {
    color: #6aaa7d; /* Highlight color for active state */
}
.button a{
    width: 135px;
    height: 35px;
    color: #e9ecef;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;


}
.button:hover {
    background-color: #ffffff;;

}
.button {
    background-color: #282c34;
    width: 135px;
    height: 35px;
    text-align: center;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 20px;
    border-radius: 10px;
    display: flex;
    margin-right: 30px;
    padding: 0;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
    border: none; /* 테두리 제거 */
}

.button a {
    width: 100%;
    height: 100%;
    color: #e9ecef;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    border: none; /* a 요소의 테두리 제거 */
}
.auth-button {
    width: 100%; /* 부모 .button 요소의 너비에 맞춤 */
    height: 100%; /* 부모 .button 요소의 높이에 맞춤 */
    color: #e9ecef;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    background: none; /* 버튼 배경 투명 */
    border: none; /* 기본 버튼 테두리 제거 */
    cursor: pointer;
    border-radius: 10px; /* 버튼 모서리 둥글게 */
}

.auth-button:hover {
    background-color: #ffffff; /* 호버 시 배경색 변경 */
    color: #282c34; /* 호버 시 텍스트 색상 변경 */
}
.button:hover {
    background-color: #ffffff;
}

.button:hover a {
    color: #353535;
}

.dropdown-container {
    background-color: rgba(255, 255, 255, 0.96);
    border-top: 2px solid #a7c898;
    flex-direction: column;
    position: absolute;
    width: 200px;
    /*right:0;*/
    /*top: 43px; !* 네비게이션 바 바로 아래에 위치 *!*/
    top:180%;
    display: none;
    justify-content: center;
    align-items: center;

    z-index: 1; /* 드롭다운 메뉴가 다른 요소들 위에 표시되도록 설정 */
    left: 50%; /* 가운데 정렬을 위한 기준 설정 */
    transform: translateX(-50%); /* 왼쪽으로 반만 이동하여 가운데 정렬 */
}

.dropdown-container {
    list-style: none;
    padding: 0;
    margin: 10px 0;
}

.dropdown-container li {
    margin: 0;
    padding: 10px 50px;
    width: 100%; /* li 요소가 드롭다운의 전체 너비를 차지하도록 설정 */
    box-sizing: border-box;
}


.dropdown-container li a {
    color: #343a40;
    text-decoration: none;
    font-weight: normal;

    display: block; /* a 요소가 li 전체를 차지하도록 설정 */
    width: 100%; /* a 요소도 드롭다운의 전체 너비를 차지하도록 설정 */
    height: 100%; /* a 요소가 li 요소의 전체 높이를 차지하도록 설정 */
    box-sizing: border-box;
    padding: 10px 20px; /* padding을 li와 동일하게 설정 */
}

.dropdown-container li:hover a{
    color: #ffffff;
    background-color: #a7c898;
}
.dropdown-container li:hover {
    background-color: #a7c898;


}


.custom-button {
    background-color: #282c34; /* 원하는 배경색 */
    color: #e9ecef; /* 텍스트 색상 */
    border: none; /* 기본 버튼 테두리 제거 */
    padding: 5px 5%; /* 패딩을 추가해 크기 조정 */
    border-radius: 10px; /* 모서리 둥글게 */
    cursor: pointer;
    width: 135px;
    height: 35px;
    font-size: 16px; /* 폰트 크기 */
    font-weight: normal;
    transition: background-color 0.3s ease, color 0.3s ease; /* 호버 효과 전환 */
}

.custom-button:hover {
    background-color: #ffffff; /* 호버 시 배경색 */
    color: #353535; /* 호버 시 텍스트 색상 */
}

.custom-button:focus {
    outline: none; /* 포커스 시 기본 아웃라인 제거 */
}

nav ul li {
    font-weight: bold;
    cursor: pointer;
    padding: 10px;
    transition: color 0.3s ease-in-out;
}

/* 선택된 상위 메뉴 스타일 */
nav ul li.active {
    color: #6aaa7d; /* 선택된 메뉴 색상 */
    background: #e9ecef;
}

/* 드롭다운 내부 항목은 기본 폰트 */
nav ul li ul li {
    font-weight: normal;
    color: black;
}
.hamburger-menu {
    display: none;
    cursor: pointer;
    position: absolute;
    right: 80px;
    /*top: 45px;*/

    z-index: 100;

}

/* 모바일 메뉴 스타일 */
.mobile-menu {
    display: none;
    position: absolute;
    /*top: 100px;*/
    left: 0;
    width: 100%;

    background: #f8f9fa; /* 드롭다운 배경색 변경 */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 100px 0 100px 0;


    z-index: 99;
    cursor: pointer;
}

.mobile-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
    padding-top: 10px;
    /*padding-bottom: 80px;*/

}

.mobile-menu li {
    padding: 10px 20px;
    /*border-bottom: 1px solid #ddd;*/
    transition: background 0.3s ease-in-out;
}

/* hover 시 배경색 변경 */
.mobile-menu li:hover {
    /*background: #e9ecef;*/
}

.mobile-menu li a {
    text-decoration: none;
    color: black;
    transition: color 0.3s ease-in-out;
}

/* hover 시 글자색 변경 */
.mobile-menu li a:hover {
    color: #6aaa7d;
}

/* 활성화 시 메뉴 표시 */
.mobile-menu.open {
    display: block;
}

@media (max-width: 768px) {
    .nav-menu {
        display: none;
    }

    .upper {
        display: none;
    }
    .header{
        margin: -15px 0;

    }

    .hamburger-menu {
        display: block;
    }

    .lower {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .logo {
        position: static;
        margin-bottom: 5px;
        margin-left: 10px; /* 왼쪽 정렬 */
    }

    .button {
        display: none;
    }

    }


/* 상단 링크 스타일 */
.other-menu {
    display: flex;
    justify-content: center;
    padding: 10px 0;
    margin-top: 80px;


}
 .other-menu2{
    display: flex;
    justify-content: center;


}

.other-menu ul, .other-menu2 ul {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    color: #5c5c5c;
}

.other-menu li, .other-menu2 li {
    padding: 5px 10px;
    color: #5c5c5c;
}

.other-menu a, .other-menu2 a {
    text-decoration: none;
    font-size: 14px;
    color: #a3a1a1;
}

.other-menu a:hover, .other-menu2 a:hover {
    color: #6aaa7d;
}

/* 구분점 스타일 */
.dot {
    color: #999;
    margin: 0 5px;
}

/* 모바일 메뉴 스타일 */
.mobile-menu {
    display: none;
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    background: white;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 20px 0;
    z-index: 99;
    cursor: pointer;
}

.mobile-menu.open {
    display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe,EAAE,UAAU;IAC3B,MAAM,EAAE,cAAc;IACtB,WAAW,EAAE,uBAAuB;IACpC,aAAa,EAAE,uBAAuB;IACtC,wCAAwC;;IAExC;;;;;KAKC;IACD,0BAA0B;IAC1B,kCAAkC;AACtC;AACA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,kCAAkC,EAAE,gBAAgB;IACpD,gCAAgC,EAAE,iBAAiB;IACnD,aAAa;IACb;QACI,yBAAyB;IAC7B;;AAEJ;;;AAGA;IACI,iBAAiB;IACjB,wCAAwC;IACxC,UAAU;IACV,MAAM;IACN,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;;AAE3B;;;AAGA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,SAAS;AACb;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,SAAS;AACb;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA,UAAU;AACV,0BAA0B;AAC1B,kBAAkB;AAClB,+BAA+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC,QAAQ;AACR,WAAW;AACX,qBAAqB;AACrB,8CAA8C;AAC9C,0BAA0B;AAC1B,gCAAgC;AAChC,mBAAmB;AACnB,IAAI;AACJ;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;;AAEd;;AAEA;IACI,WAAW;;AAEf;;;;AAIA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,UAAU;AACd;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,aAAa,EAAE,qBAAqB;AACxC;AACA;IACI,aAAa,EAAE,qBAAqB;AACxC;AACA;IACI,aAAa,EAAE,qBAAqB;AACxC;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,iBAAiB;;AAErB;;;;AAIA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,wDAAwD;IACxD,gDAAgD;IAChD,iDAAiD;IACjD,kBAAkB,EAAE,kDAAkD;AAC1E;;AAEA;IACI,WAAW,EAAE,mBAAmB;IAChC,kBAAkB;IAClB,aAAa,EAAE,gBAAgB;IAC/B,OAAO;IACP,QAAQ;IACR,YAAY,EAAE,sBAAsB;IACpC,mCAAmC;AACvC;;AAEA;;IAEI,cAAc,EAAE,kBAAkB;AACtC;;AAEA;;IAEI,aAAa,EAAE,qBAAqB;AACxC;;AAEA;IACI,cAAc;AAClB;AACA;;IAEI,cAAc,EAAE,uCAAuC;AAC3D;;AAEA;IACI,cAAc,EAAE,qCAAqC;AACzD;AACA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;;AAG3B;AACA;IACI,yBAAyB;;AAE7B;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,uDAAuD;IACvD,YAAY,EAAE,WAAW;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY,EAAE,iBAAiB;AACnC;AACA;IACI,WAAW,EAAE,0BAA0B;IACvC,YAAY,EAAE,0BAA0B;IACxC,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB,EAAE,aAAa;IAC/B,YAAY,EAAE,iBAAiB;IAC/B,eAAe;IACf,mBAAmB,EAAE,eAAe;AACxC;;AAEA;IACI,yBAAyB,EAAE,gBAAgB;IAC3C,cAAc,EAAE,mBAAmB;AACvC;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2CAA2C;IAC3C,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,qCAAqC;IACrC,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,UAAU,EAAE,gCAAgC;IAC5C,SAAS,EAAE,qBAAqB;IAChC,2BAA2B,EAAE,wBAAwB;AACzD;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW,EAAE,iCAAiC;IAC9C,sBAAsB;AAC1B;;;AAGA;IACI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;;IAEnB,cAAc,EAAE,0BAA0B;IAC1C,WAAW,EAAE,gCAAgC;IAC7C,YAAY,EAAE,iCAAiC;IAC/C,sBAAsB;IACtB,kBAAkB,EAAE,yBAAyB;AACjD;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,yBAAyB;;;AAG7B;;;AAGA;IACI,yBAAyB,EAAE,YAAY;IACvC,cAAc,EAAE,WAAW;IAC3B,YAAY,EAAE,iBAAiB;IAC/B,eAAe,EAAE,kBAAkB;IACnC,mBAAmB,EAAE,YAAY;IACjC,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,eAAe,EAAE,UAAU;IAC3B,mBAAmB;IACnB,uDAAuD,EAAE,aAAa;AAC1E;;AAEA;IACI,yBAAyB,EAAE,aAAa;IACxC,cAAc,EAAE,gBAAgB;AACpC;;AAEA;IACI,aAAa,EAAE,qBAAqB;AACxC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,kCAAkC;AACtC;;AAEA,kBAAkB;AAClB;IACI,cAAc,EAAE,cAAc;IAC9B,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,aAAa;;IAEb,YAAY;;AAEhB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,OAAO;IACP,WAAW;;IAEX,mBAAmB,EAAE,gBAAgB;IACrC,wCAAwC;IACxC,wBAAwB;;;IAGxB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,wBAAwB;;AAE5B;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,uCAAuC;AAC3C;;AAEA,mBAAmB;AACnB;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,kCAAkC;AACtC;;AAEA,mBAAmB;AACnB;IACI,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;IACA;QACI,eAAe;;IAEnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB,EAAE,UAAU;IACjC;;IAEA;QACI,aAAa;IACjB;;IAEA;;;AAGJ,cAAc;AACd;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,gBAAgB;;;AAGpB;CACC;IACG,aAAa;IACb,uBAAuB;;;AAG3B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,WAAW;IACX,aAAa;AACjB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,iBAAiB;IACjB,wCAAwC;IACxC,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["\n.header {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    /*padding: 25px 25px;*/\n    position: fixed; /* 상단 고정 */\n    top: 0; /* 화면 상단에 고정 */\n    width: 100%; /* 화면 전체 너비를 차지하도록 설정 */\n    z-index: 1000; /* 다른 요소들 위에 표시되도록 설정 */\n    /*background: rgba(255, 255, 255, 0.2);*/\n\n    background: linear-gradient(\n            to bottom,\n            rgba(255, 255, 255, 0.2), /* 상단에서 60% 불투명도 */\n            rgba(255, 255, 255, 0.1), /* 중간에서 40% 불투명도 */\n            rgba(255, 255, 255, 0)    /* 하단에서 완전 투명 */\n    );\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n}\n.dot{\n    color: #889daa;\n    margin: 0 5px;\n}\n\n.header.scrolled {\n    background: rgba(255, 255, 255, 1); /* 스크롤 시 흰색 배경 */\n    border-bottom: 2px solid #a7c898; /* 스크롤 시 테두리 변경 */\n    z-index: 1000;\n    .upper{\n        background-color: #a7c898;\n    }\n\n}\n\n\n.upper{\n    padding: 8px 50px;\n    /*background-color: rgb(198, 225, 251);*/\n    width:100%;\n    top: 0;\n    /*padding: 10px 0;*/\n    box-sizing: border-box;\n    /*justify-content: center;*/\n    /*align-items: center;*/\n\n}\n\n\n.upper .upnav-menu  ul li {\n    list-style: none;\n    display: flex;\n    justify-content: center;\n    padding: 0;\n    margin: 0;\n}\n.upnav-menu a {\n    text-decoration: none;\n    color: #5d6b73;\n}\n.upnav-menu a:hover {\n    text-decoration: none;\n    color: #6aaa7d;\n}\n\n.upnav-menu ul {\n    list-style: none;\n    display: flex;\n    margin: 0;\n    padding: 0;\n}\n\n.upper .upnav-menu2  ul li {\n    list-style: none;\n    display: flex;\n    justify-content: center;\n    padding: 0;\n    margin: 0;\n}\n.upnav-menu2 a{\n    text-decoration: none;\n    color: #5d6b73;\n}\n.upnav-menu2 ul {\n    list-style: none;\n    display: flex;\n    margin: 0;\n    padding: 0;\n    position: absolute;\n    right: 20px;\n    top: 8px;\n}\n.upnav-menu2 a:hover {\n    text-decoration: none;\n    color: #6aaa7d;\n}\n\n/*.lower{*/\n/*    padding: 25px 25px;*/\n/*    width:100%;*/\n/*    justify-content: center;*/\n/*    align-items: center;*/\n/*    background-color: #f8f9fa;*/\n/*!*}*!*/\n/*.upper {*/\n/*    display: flex;*/\n/*    justify-content: flex-end; !* 오른쪽 정렬 *!*/\n/*    padding: 10px 25px;*/\n/*    background-color:#E1BEE1;*/\n/*    width: 100%;*/\n/*}*/\n.lower {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 30px 20px;\n    position: relative;\n}\n\n\n.logo {\n    position: absolute;\n    left: 50px;\n\n}\n\n.logo img {\n    height:70px;\n\n}\n\n\n\n.nav-menu ul {\n    list-style: none;\n    display: flex;\n    margin: 0;\n    padding: 0;\n}\n\n\n.nav-menu li {\n    margin-right: 40px;\n    position: relative;\n\n}\n\n.nav-menu li:last-child {\n    margin-right: 0;\n}\n\n.nav-menu li:hover .dropdown-container,\n.dropdown-container:hover {\n    display: flex; /* 드롭다운 메뉴가 보이도록 설정 */\n}\n.nav-menu li:hover{\n    display: flex; /* 드롭다운 메뉴가 보이도록 설정 */\n}\n.dropdown-container{\n    display: flex; /* 드롭다운 메뉴가 보이도록 설정 */\n}\n.nav-menu a {\n    text-decoration: none;\n    color: #565b61;\n    font-weight: bold;\n\n}\n\n\n\n.navtitle {\n    color: rgb(0, 0, 0);\n    font-weight: bold;\n    cursor: pointer;\n    /*filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.7))*/\n    /*drop-shadow(0 0 2px rgba(255, 255, 255, 0.7))*/\n    /*drop-shadow(0 0 2px rgba(255, 255, 255, 0.7));*/\n    position: relative; /* ::after 가상 요소를 사용하기 위해 position을 relative로 설정 */\n}\n\n.navtitle::after {\n    content: ''; /* 내용 없이 가상 요소 생성 */\n    position: absolute;\n    bottom: -40px; /* 아래로 20px 확장 */\n    left: 0;\n    right: 0;\n    height: 20px; /* 20px의 hover 영역 추가 */\n    /* 확장된 영역에 마우스를 올리면 드롭다운이 보이도록 설정 */\n}\n\n.navtitle:hover,\n.navtitle::after:hover {\n    color: #6aaa7d; /* hover 시 색상 변경 */\n}\n\n.navtitle:hover .dropdown-container,\n.navtitle::after:hover .dropdown-container {\n    display: flex; /* 드롭다운 메뉴가 보이도록 설정 */\n}\n\n.nav-menu a:hover {\n    color: #6aaa7d;\n}\n.nav-menu li:hover .navtitle,\n.nav-menu li:hover .dropdown-container:hover {\n    color: #6aaa7d; /* 드롭다운 위로 커서를 옮겼을 때에도 navtitle 색상 유지 */\n}\n\n.navtitle.active {\n    color: #6aaa7d; /* Highlight color for active state */\n}\n.button a{\n    width: 135px;\n    height: 35px;\n    color: #e9ecef;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n\n}\n.button:hover {\n    background-color: #ffffff;;\n\n}\n.button {\n    background-color: #282c34;\n    width: 135px;\n    height: 35px;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    right: 20px;\n    border-radius: 10px;\n    display: flex;\n    margin-right: 30px;\n    padding: 0;\n    cursor: pointer;\n    transition: background-color 0.3s ease, color 0.3s ease;\n    border: none; /* 테두리 제거 */\n}\n\n.button a {\n    width: 100%;\n    height: 100%;\n    color: #e9ecef;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    border: none; /* a 요소의 테두리 제거 */\n}\n.auth-button {\n    width: 100%; /* 부모 .button 요소의 너비에 맞춤 */\n    height: 100%; /* 부모 .button 요소의 높이에 맞춤 */\n    color: #e9ecef;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    background: none; /* 버튼 배경 투명 */\n    border: none; /* 기본 버튼 테두리 제거 */\n    cursor: pointer;\n    border-radius: 10px; /* 버튼 모서리 둥글게 */\n}\n\n.auth-button:hover {\n    background-color: #ffffff; /* 호버 시 배경색 변경 */\n    color: #282c34; /* 호버 시 텍스트 색상 변경 */\n}\n.button:hover {\n    background-color: #ffffff;\n}\n\n.button:hover a {\n    color: #353535;\n}\n\n.dropdown-container {\n    background-color: rgba(255, 255, 255, 0.96);\n    border-top: 2px solid #a7c898;\n    flex-direction: column;\n    position: absolute;\n    width: 200px;\n    /*right:0;*/\n    /*top: 43px; !* 네비게이션 바 바로 아래에 위치 *!*/\n    top:180%;\n    display: none;\n    justify-content: center;\n    align-items: center;\n\n    z-index: 1; /* 드롭다운 메뉴가 다른 요소들 위에 표시되도록 설정 */\n    left: 50%; /* 가운데 정렬을 위한 기준 설정 */\n    transform: translateX(-50%); /* 왼쪽으로 반만 이동하여 가운데 정렬 */\n}\n\n.dropdown-container {\n    list-style: none;\n    padding: 0;\n    margin: 10px 0;\n}\n\n.dropdown-container li {\n    margin: 0;\n    padding: 10px 50px;\n    width: 100%; /* li 요소가 드롭다운의 전체 너비를 차지하도록 설정 */\n    box-sizing: border-box;\n}\n\n\n.dropdown-container li a {\n    color: #343a40;\n    text-decoration: none;\n    font-weight: normal;\n\n    display: block; /* a 요소가 li 전체를 차지하도록 설정 */\n    width: 100%; /* a 요소도 드롭다운의 전체 너비를 차지하도록 설정 */\n    height: 100%; /* a 요소가 li 요소의 전체 높이를 차지하도록 설정 */\n    box-sizing: border-box;\n    padding: 10px 20px; /* padding을 li와 동일하게 설정 */\n}\n\n.dropdown-container li:hover a{\n    color: #ffffff;\n    background-color: #a7c898;\n}\n.dropdown-container li:hover {\n    background-color: #a7c898;\n\n\n}\n\n\n.custom-button {\n    background-color: #282c34; /* 원하는 배경색 */\n    color: #e9ecef; /* 텍스트 색상 */\n    border: none; /* 기본 버튼 테두리 제거 */\n    padding: 5px 5%; /* 패딩을 추가해 크기 조정 */\n    border-radius: 10px; /* 모서리 둥글게 */\n    cursor: pointer;\n    width: 135px;\n    height: 35px;\n    font-size: 16px; /* 폰트 크기 */\n    font-weight: normal;\n    transition: background-color 0.3s ease, color 0.3s ease; /* 호버 효과 전환 */\n}\n\n.custom-button:hover {\n    background-color: #ffffff; /* 호버 시 배경색 */\n    color: #353535; /* 호버 시 텍스트 색상 */\n}\n\n.custom-button:focus {\n    outline: none; /* 포커스 시 기본 아웃라인 제거 */\n}\n\nnav ul li {\n    font-weight: bold;\n    cursor: pointer;\n    padding: 10px;\n    transition: color 0.3s ease-in-out;\n}\n\n/* 선택된 상위 메뉴 스타일 */\nnav ul li.active {\n    color: #6aaa7d; /* 선택된 메뉴 색상 */\n    background: #e9ecef;\n}\n\n/* 드롭다운 내부 항목은 기본 폰트 */\nnav ul li ul li {\n    font-weight: normal;\n    color: black;\n}\n.hamburger-menu {\n    display: none;\n    cursor: pointer;\n    position: absolute;\n    right: 80px;\n    /*top: 45px;*/\n\n    z-index: 100;\n\n}\n\n/* 모바일 메뉴 스타일 */\n.mobile-menu {\n    display: none;\n    position: absolute;\n    /*top: 100px;*/\n    left: 0;\n    width: 100%;\n\n    background: #f8f9fa; /* 드롭다운 배경색 변경 */\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    padding: 100px 0 100px 0;\n\n\n    z-index: 99;\n    cursor: pointer;\n}\n\n.mobile-menu ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    padding-top: 10px;\n    /*padding-bottom: 80px;*/\n\n}\n\n.mobile-menu li {\n    padding: 10px 20px;\n    /*border-bottom: 1px solid #ddd;*/\n    transition: background 0.3s ease-in-out;\n}\n\n/* hover 시 배경색 변경 */\n.mobile-menu li:hover {\n    /*background: #e9ecef;*/\n}\n\n.mobile-menu li a {\n    text-decoration: none;\n    color: black;\n    transition: color 0.3s ease-in-out;\n}\n\n/* hover 시 글자색 변경 */\n.mobile-menu li a:hover {\n    color: #6aaa7d;\n}\n\n/* 활성화 시 메뉴 표시 */\n.mobile-menu.open {\n    display: block;\n}\n\n@media (max-width: 768px) {\n    .nav-menu {\n        display: none;\n    }\n\n    .upper {\n        display: none;\n    }\n    .header{\n        margin: -15px 0;\n\n    }\n\n    .hamburger-menu {\n        display: block;\n    }\n\n    .lower {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .logo {\n        position: static;\n        margin-bottom: 5px;\n        margin-left: 10px; /* 왼쪽 정렬 */\n    }\n\n    .button {\n        display: none;\n    }\n\n    }\n\n\n/* 상단 링크 스타일 */\n.other-menu {\n    display: flex;\n    justify-content: center;\n    padding: 10px 0;\n    margin-top: 80px;\n\n\n}\n .other-menu2{\n    display: flex;\n    justify-content: center;\n\n\n}\n\n.other-menu ul, .other-menu2 ul {\n    display: flex;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    color: #5c5c5c;\n}\n\n.other-menu li, .other-menu2 li {\n    padding: 5px 10px;\n    color: #5c5c5c;\n}\n\n.other-menu a, .other-menu2 a {\n    text-decoration: none;\n    font-size: 14px;\n    color: #a3a1a1;\n}\n\n.other-menu a:hover, .other-menu2 a:hover {\n    color: #6aaa7d;\n}\n\n/* 구분점 스타일 */\n.dot {\n    color: #999;\n    margin: 0 5px;\n}\n\n/* 모바일 메뉴 스타일 */\n.mobile-menu {\n    display: none;\n    position: absolute;\n    top: 60px;\n    left: 0;\n    width: 100%;\n    background: white;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    padding: 20px 0;\n    z-index: 99;\n    cursor: pointer;\n}\n\n.mobile-menu.open {\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
